import { ARTIFACT_NAME_MAX_LENGTH } from "@performyard/service-contracts";

// Clamped because the seed is rarely user-typed — it's the LLM's title, or the originating
// question, neither of which is length-bounded upstream. An over-long default would 422 on save.
const clampToLimit = (value: string, limit: number = ARTIFACT_NAME_MAX_LENGTH): string => value.slice(0, limit).trim();

// Suffixes " (2)", " (3)", ... until the name doesn't collide (case-insensitively) with an
// existing artifact name — mirrors the backend's case-insensitive duplicate-name rejection.
export const buildUniqueArtifactName = (baseName: string, existingNames: string[]): string => {
	const taken = new Set(existingNames.map((name) => name.trim().toLowerCase()));
	const clampedBase = clampToLimit(baseName);
	if (!taken.has(clampedBase.toLowerCase())) return clampedBase;

	// The suffix has to fit inside the limit too, so the base shrinks to make room for it.
	const withSuffix = (n: number): string => {
		const tag = ` (${n})`;
		return `${clampToLimit(baseName, ARTIFACT_NAME_MAX_LENGTH - tag.length)}${tag}`;
	};

	let suffix = 2;
	while (taken.has(withSuffix(suffix).toLowerCase())) suffix += 1;
	return withSuffix(suffix);
};

export default buildUniqueArtifactName;
